import { createStore } from 'vuex'

export default createStore({
  state: {
    user: null,
    errors: null,
    authToken: 'invalid',
    routeMeta: null,
    datos: [],
    menu: [],
    isLoading: false,
    loadings: 0,
  },
  getters: {
    loading: state => state.loading
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload
    },
    setErrors(state, errors) {
      state.errors = errors
    },
    setAuthToken(state, token) {
      state.authToken = token;
    },
    setRouteMeta(state, meta) {
      state.routeMeta = meta;
    },
    setDatos(state, payload) {
      state.datos = payload
    },
    setMenu(state, payload) {
      state.menu = payload
    },
    setLoading(state, loading) {
      if(loading) {
        state.loadings++
      } else {
        state.loadings--
      }
      state.isLoading = (state.loadings > 0)
    }
  },
  actions: {
    setAuthToken({ commit }, token) {
      commit('setAuthToken', token);
    },
    setRouteMeta({ commit }, meta) {
      commit('setRouteMeta', meta);
    },
    async fetchDatos({commit}) {
      try {
        const resDatos = await fetch('datos')
        const datos = await resDatos.json()
        commit('setDatos', datos)
      } catch (error) {
        console.log(error)
      }
    },
    async fetchMenu({commit}) {
      try {
        const resMenu = await fetch('menu')
        const menu = await resMenu.json()
        commit('setMenu', menu)
      } catch (error) {
        console.log(error)
      }
    },
    async login({commit}, { router, datos }) {
      commit("setLoading", true)
      commit("setErrors", {}, { root: true })
      try {
        const response = await fetch('user/login', {
          method: 'POST',
          body: JSON.stringify(datos)
        })
        const responseData = await response.json()
        if (!response.ok || !responseData.token) {
          throw new Error('Failed to login');
        }
        //const follow = responseData.data?.menu[0]?.module ? responseData.data.menu[0].module : 'home'
        //this.$router.push({ name: "home" });
        commit("setUser", responseData.data)
        localStorage.setItem("authToken",responseData.token);
        router.push({ name: "home" })
        // Redirect to another page or handle successful login
      } catch (err) {
        commit("setUser", null);
        localStorage.removeItem("authToken")
      } finally {
        commit("setLoading", false)      
      }
    },
    logout({commit}) {
      commit("setUser", null);
      localStorage.removeItem("authToken")
    }
  },
  modules: {
  }
})
